import { OrderDoubleTheDonationSlice } from './order-double-the-donation-types'

export const makeOrderDoubleTheDonationInitialState = (): OrderDoubleTheDonationSlice => {
  return {}
}
